import {
  LoginForm,
  setSessionTimeout,
  useSessionContext,
  useStickySafeNavigate,
} from '@equifinance/shared';
import useLoginRedirect from '@equifinance/shared/src/routing/LoginRedirect/useLoginRedirect';

function Login() {
  const navigate = useStickySafeNavigate();
  const { setIsLoggedOut } = useSessionContext();

  const { loginRedirect } = useLoginRedirect();

  const onAuth = () => {
    setSessionTimeout(false);
    setIsLoggedOut(false);
    navigate(loginRedirect);
  };

  return (
    <LoginForm onAuth={onAuth} />
  );
}

export default Login;
